import React from 'react';
import { Button } from 'glic-ui-components';
import ParentComponent from '../index';
import './index.scss';
import metaLogo from "../../../../assets/guardian.png";
import { Helmet } from "react-helmet";
import { setDomainUrl } from '../../../../utils/commonFunctions';
import { constantsObject } from './constants';

const FailedRegistration = ({ token, message }) => {

  console.log("message>>>>>", message);

  const viewIDCardBtn = (token) => {
    const host = window.location.host;
    window.location.href = `${setDomainUrl(host)}/welcome/${token}/idcard`;
  };

  let alertMainHeading = constantsObject.internalServerErrorHeading;
  let alertInfoText = constantsObject.internalServerErrorBody;

  if (message === "CRU") {
    alertMainHeading = constantsObject.registrationFailedHeading;
    alertInfoText = constantsObject.registrationFailedBody;
  }

  const registerBtn = (
    <Button
      onClick={() => viewIDCardBtn(token)}
      type="primary"
      className="register_button"
    >
      View my card
    </Button>
  );

  const failedRegistrationPropsData = {
    alertMainHeading,
    alertInfoText,
    registerBtn,
  };

  return (
    <>
      <Helmet>
        <title>Registration has failed | Guardian</title>
        <link rel="icon" type="image/png" href={metaLogo} />
      </Helmet>
      <ParentComponent propData={failedRegistrationPropsData} />
    </>
  );
};

export default FailedRegistration;
